import { ReactElement } from 'react';
import { ManualAddress } from 'ia-react-core/~/interfaces/ManualAddress';
import compose from '../../../utils/components/_compose';
import injectTranslations from '../../../hocs/translation/injectTranslations';

import fr from './translations/fr';
import en from './translations/en';

import withForm from './withForm';
import ManualAddressForm, { ManualAddressFormProps } from './ManualAddressForm';

const ComposedManualAddressForm: (<
  CustomAddress extends object = ManualAddress,
  AddressKey extends keyof CustomAddress = keyof CustomAddress
>(props: ManualAddressFormProps<CustomAddress, AddressKey>) => ReactElement<ManualAddressFormProps<CustomAddress, AddressKey>>) & {
  displayName: string;
  defaultProps: typeof ManualAddressForm.defaultProps;
} = compose<any>(
  injectTranslations('Core.ManualAddressForm', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  withForm,
)(ManualAddressForm);

ComposedManualAddressForm.displayName = 'ManualAddressForm';
ComposedManualAddressForm.defaultProps = ManualAddressForm.defaultProps;

export * from './ManualAddressForm';
export default ComposedManualAddressForm;
